// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__27hzq","detailsBorder":"styles_detailsBorder__1ZUZU"};